import { useEffect, useState } from 'react'
import Box from 'components/shared/Box'
import Text from 'components/shared/Text'
import Select from 'components/shared/Select'
import { TransportRouteType } from 'store/api-slice/types'
import { useListTransportRouteTypesQuery } from 'store/api-slice/hooks'
import { OptionProps } from 'components/shared/Select/index'
import { useIntl, defineMessages } from 'react-intl'
import Loader from 'components/shared/Loader'
import { useApp } from 'store/steps'

interface BusRouteProps {
    routeId: number | string
    routeOption: TransportRouteType
    setRouteOption: (route: TransportRouteType) => void
    setIsDataFetched: (isFetched: boolean) => void
    testIdPrefix?: string
}

export const BusRoute = ({
    routeId,
    routeOption,
    setRouteOption,
    setIsDataFetched,
    testIdPrefix,
}: BusRouteProps) => {
    const { formatMessage } = useIntl()
    const { language } = useApp()

    const { data, isFetching, isError } = useListTransportRouteTypesQuery({
        _locale: language,
    })

    const [options, setOptions] = useState<OptionProps[]>([
        { option: '', value: '' },
    ])

    const isDataFetched = !isFetching && !isError

    const optionName = defineMessages({
        to_from_park: {
            id: 'upsells.transport.route_to_from_park',
            defaultMessage: 'Tam i z powrotem',
        },
        to_park: {
            id: 'upsells.transport.route_to_park',
            defaultMessage: 'Do parku',
        },
        from_park: {
            id: 'upsells.transport.route_from_park',
            defaultMessage: 'Z parku',
        },
    })

    const handleRouteTypeChange = (value: string) => {
        if (value !== routeOption) setRouteOption(value as TransportRouteType)
    }

    const formatOptions = () => {
        if (!data) return
        const optionsArr: OptionProps[] = []
        const { types } = data

        types?.forEach((option) => {
            const { label, value } = option
            if (!label) return
            optionsArr.push({
                option: label,
                value,
            })
        })

        return setOptions(optionsArr)
    }

    useEffect(() => {
        setIsDataFetched(isDataFetched)
        if (!isDataFetched || !data) return
        formatOptions()
    }, [isDataFetched])

    return (
        <Box gap={8} isFullWidth>
            <Text variant="heading4">
                {formatMessage({
                    id: 'upsells.transport.route_selector_label',
                    defaultMessage: 'Wybierz trasę',
                })}
            </Text>

            {!isDataFetched ? (
                <Loader />
            ) : (
                <Select
                    id="route"
                    options={options}
                    value={formatMessage(optionName[routeOption])}
                    onChange={handleRouteTypeChange}
                    testId={`${
                        testIdPrefix ?? `transport-${routeId}`
                    }-route-select`}
                />
            )}
        </Box>
    )
}
